"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNoPayoutSubtitleKey = exports.getProcessingTimeKey = exports.getNextMonthThirdPayoutDate = exports.getMonthlyPayoutDates = exports.getEndDateForNextMondayPayoutDate = void 0;
const luxon_1 = require("luxon");
const enums_1 = require("../../enums");
const dates_1 = require("../../helpers/dates");
const country_1 = require("../enums/country");
const getEndDateForNextMondayPayoutDate = (organizationCountry, nextPayoutDate, startDate) => {
    if (organizationCountry === country_1.OrganizationCountry.UnitedStates) {
        // endDate: Always the Thursday 23:59:59.999 before the payout date
        const endDate = new Date(nextPayoutDate);
        const payoutDayOfWeek = nextPayoutDate.getDay();
        const daysToSubtract = payoutDayOfWeek >= 4 ? payoutDayOfWeek - 4 : payoutDayOfWeek + 3;
        endDate.setDate(nextPayoutDate.getDate() - daysToSubtract);
        endDate.setHours(23, 59, 59, 999);
        return {
            startDate,
            endDate,
            nextPayoutDate,
        };
    }
    else {
        // endDate: Always 7 days before the nextPayoutDate
        const endDate = new Date(nextPayoutDate);
        endDate.setDate(nextPayoutDate.getDate() - 7);
        endDate.setHours(23, 59, 59, 999);
        return {
            startDate,
            endDate,
            nextPayoutDate,
        };
    }
};
exports.getEndDateForNextMondayPayoutDate = getEndDateForNextMondayPayoutDate;
/**
 * Calculates monthly payout dates based on organization country and current date.
 *
 * Business Rules:
 *
 * United States:
 * - startDate: Always 2 months before the current date
 * - nextPayoutDate: Always the next 3rd of the month
 * - endDate: 2 days before the nextPayoutDate.
 * If the nextPayoutDate is on Monday so the endDate is the previous thursday.
 * If the nextPayoutDate is on Tuesday so the endDate is the previous Friday.
 *
 * Canada:
 * - startDate: Always 2 months before the current date
 * - nextPayoutDate: Always the 3rd of next month
 * - endDate: Always 7 days before the nextPayoutDate
 *
 * @param now - Current date
 * @param organizationCountry - Organization country (US or Canada)
 * @returns Object containing startDate, endDate, and nextPayoutDate
 */
const getMonthlyPayoutDates = (now, organizationCountry) => {
    const startDate = (0, dates_1.getDateMinusNMonths)(now, 2);
    startDate.setHours(0, 0, 0, 0);
    const nextPayoutDate = (0, exports.getNextMonthThirdPayoutDate)(now);
    if (organizationCountry === country_1.OrganizationCountry.UnitedStates) {
        // endDate: 2 days before the nextPayoutDate, except if it's Monday or Tuesday
        const endDate = new Date(nextPayoutDate);
        const payoutDayOfWeek = nextPayoutDate.getDay();
        if (payoutDayOfWeek === 1) {
            // Monday
            // endDate = previous Thursday
            endDate.setDate(nextPayoutDate.getDate() - 4);
        }
        else if (payoutDayOfWeek === 2) {
            // Tuesday
            // endDate = previous Friday
            endDate.setDate(nextPayoutDate.getDate() - 3);
        }
        else {
            // Other days: 2 days before
            endDate.setDate(nextPayoutDate.getDate() - 2);
        }
        endDate.setHours(23, 59, 59, 999);
        return {
            startDate,
            endDate,
            nextPayoutDate,
        };
    }
    else {
        // endDate = 7 days before the nextPayoutDate
        const endDate = new Date(nextPayoutDate);
        endDate.setDate(nextPayoutDate.getDate() - 7);
        endDate.setHours(23, 59, 59, 999);
        return {
            startDate,
            endDate,
            nextPayoutDate,
        };
    }
};
exports.getMonthlyPayoutDates = getMonthlyPayoutDates;
/**
 * Helper function to calculate the next month's 3rd day payout date
 * @param now - Current date
 * @returns Date object set to the 3rd of next month, adjusted to Monday if weekend
 */
const getNextMonthThirdPayoutDate = (now) => {
    const nowDateTime = luxon_1.DateTime.fromJSDate(now);
    // Get the 3rd of next month
    const thirdOfNextMonth = nowDateTime.plus({ months: 1 }).set({ day: 3 }).startOf("day");
    // Adjust to Monday if it's weekend
    let nextPayoutDate;
    if (thirdOfNextMonth.weekday === 6) {
        // Saturday - move to Monday
        nextPayoutDate = thirdOfNextMonth.plus({ days: 2 });
    }
    else if (thirdOfNextMonth.weekday === 7) {
        // Sunday - move to Monday
        nextPayoutDate = thirdOfNextMonth.plus({ days: 1 });
    }
    else {
        // Weekday - keep as is
        nextPayoutDate = thirdOfNextMonth;
    }
    const result = nextPayoutDate.toJSDate();
    result.setHours(12, 0, 0, 0);
    return result;
};
exports.getNextMonthThirdPayoutDate = getNextMonthThirdPayoutDate;
const getProcessingTimeKey = (organizationCountry) => {
    if (organizationCountry === country_1.OrganizationCountry.Canada) {
        return "notification.processingTime.ca";
    }
    else {
        return "notification.processingTime.us";
    }
};
exports.getProcessingTimeKey = getProcessingTimeKey;
const getNoPayoutSubtitleKey = (payoutInterval, country) => {
    if (payoutInterval === enums_1.PayoutInterval.Weekly) {
        return country === country_1.OrganizationCountry.UnitedStates ? "us.weekly" : "ca.weekly";
    }
    return country === country_1.OrganizationCountry.UnitedStates ? "us.monthly" : "ca.monthly";
};
exports.getNoPayoutSubtitleKey = getNoPayoutSubtitleKey;
